
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/antiviruschoice",
      function () {
        return require("private-next-pages/antiviruschoice/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/antiviruschoice"])
      });
    }
  